import { compose } from '../../utils/compose';
import { withLocalization } from '../../shared/Context/LocalizationContext';
import { withLocationContext } from './LocationContext';
import Hero from './Hero';
import OfficeList from './OfficeList';
import 'swiper/css/pagination';
import 'swiper/css';

const LocationDetail = (props) => (
  <>
    <Hero />
    <OfficeList thankYouMessage={props.thankYouMessage} />
  </>
);

export default compose(withLocalization, withLocationContext)(LocationDetail);
